import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './axios/axios-api'
import { createPortalVuetify } from './plugins/vuetify'
import { resolveInitialDarkMode } from './utils/helpers/portalDarkModePreference'
import { setupPortalPwa } from './utils/pwa/registerPortalPwa'

function renderBootError(err) {
  const el = document.getElementById('app')
  const msg = err && err.message ? String(err.message) : 'Error desconocido al cargar la configuración.'
  if (el) {
    // eslint-disable-next-line no-console
    console.error(err)
    const dark = resolveInitialDarkMode()
    const bg = dark ? '#0f141b' : '#fafafa'
    const fg = dark ? '#e7edf4' : '#333'
    const muted = dark ? '#aab7c4' : '#666'
    const buttonBg = dark ? '#151b23' : '#fff'
    const buttonBorder = dark ? '#344250' : '#ccc'
    el.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;font-family:system-ui,sans-serif;background:${bg};color:${fg};">
        <div style="max-width:420px;text-align:center;">
          <p style="font-size:16px;font-weight:600;margin:0 0 8px;">No se pudo iniciar el portal</p>
          <p style="font-size:14px;color:${muted};margin:0 0 20px;line-height:1.4;">${msg.replace(/</g, '&lt;')}</p>
          <button type="button" onclick="location.reload()" style="padding:10px 20px;font-size:14px;cursor:pointer;border-radius:8px;border:1px solid ${buttonBorder};background:${buttonBg};color:${fg};">
            Reintentar
          </button>
        </div>
      </div>
    `
  }
}

async function bootstrap() {
  await store.dispatch('portalConfig/loadPublicConfig')
  if (process.env.NODE_ENV === 'development') {
    await new Promise((resolve) => setTimeout(resolve))
  }
  const { primaryColor, secondaryColor } = store.state.portalConfig.hospitalConfig
  setupPortalPwa(store.state.portalConfig.hospitalConfig)
  const vuetify = createPortalVuetify(primaryColor, secondaryColor)
  const app = createApp(App)
  app.use(vuetify)
  app.use(store)
  app.use(router)
  app.mount('#app')
}

bootstrap().catch(renderBootError)
